import { Component, Input, OnInit } from '@angular/core';

import { EditorEligibilityOperator } from '../editor-eligibility-operator/editor-eligibility-operator.model';


@Component({
    selector: 'eas-editor-eligibility-operator-title',
    templateUrl: './editor-eligibility-operator-title.component.html',
    styleUrls: ['./editor-eligibility-operator-title.component.css'],
    standalone: false
})
export class EditorEligibilityOperatorTitleComponent implements OnInit {
  @Input() operator: EditorEligibilityOperator;

  constructor() {

  }

  ngOnInit() {

  }
}
